export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/510b60add388-tooliconshopping.jpg',
  },
  title: 'What brand is the item?',
  placeholderText: 'e.g. Samsung, Apple',
}
